import { render, staticRenderFns } from "./bigEvent.vue?vue&type=template&id=a218d32c"
import script from "./bigEvent.vue?vue&type=script&lang=js"
export * from "./bigEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports